import { constants } from '@yola/subscription-manager-js';

const { hostingPackageFeatureNames: features } = constants;

const getFeatureAvailability = (feature, featureFlags, notAvailableFeatures) => {
  const {
    ai_site_wizard: isAiSiteWizardEnabled,
    ai_page_wizard: isAiPageWizardEnabled,
    ai_block_generator: isAiBlockGeneratorEnabled,
    ai_text_assistant: isAiTextAssistantEnabled,
    ai_text_assistant_rewrite: isAiTextAssistantRewriteEnabled,
    ai_text_assistant_rewrite_v2: isAiTextAssistantRewriteV2Enabled,
    ai_text_assistant_write: isAiTextAssistantWriteEnabled,
    site_export: isSiteExportEnabled,
    freedomain: isFreeDomainFlagEnabled,
    composite_group: isCompositeGroupEnabled,
    ai_localization: isAiLocalizationEnabled,
  } = featureFlags;

  if (notAvailableFeatures.includes(feature)) {
    return false;
  }

  switch (feature) {
    case features.AI_SITE_WIZARD:
      return isAiSiteWizardEnabled || isAiPageWizardEnabled;
    case features.AI_BLOCK_GENERATOR:
      return isAiBlockGeneratorEnabled;
    case features.AI_TEXT_ASSISTANT:
      return (
        isAiTextAssistantEnabled ||
        isAiTextAssistantRewriteEnabled ||
        isAiTextAssistantRewriteV2Enabled ||
        isAiTextAssistantWriteEnabled
      );
    case features.WEBSITE_EXPORT:
      return isSiteExportEnabled;
    case features.FREE_DOMAIN_PROMO:
      return isFreeDomainFlagEnabled;
    case features.PREMIUM_COMPOSITE_GROUP:
      return isCompositeGroupEnabled;
    case features.AI_LOCALIZATION:
      return isAiLocalizationEnabled;
    default:
      return true;
  }
};

export default getFeatureAvailability;
